module.exports = __webpack_public_path__ + "images/0212eea19ede84640487dfabc8dd48d1.png";